// tslint:disable

import * as React from 'react';
import { get } from 'lodash';
import { IriField } from '../../components/fields/iri.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';

export class UserAttachPerson extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);
    private hasEmitted: any = {};

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateEndPoint('user');
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    handleEntityFieldFetched(form: FormLib, field: any, entity: string){
        if (!this.hasEmitted.hasOwnProperty(entity)){
            (form.fields[entity] as Field).setValue(get(field, 'value.@id'))
            this.hasEmitted[entity] = false;
        }
    }

    render() {
        return (
            <ResourceLoader entity="user" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div className="row">
                <LoaderComponent isLoading$={this.executor.loading$}/>

                <div className="col-xs-12">

                    <ToggleBoxComponent title="Attach person to user" alwaysOpen={true}>
                        <IriField
                            className="col-xs-12"
                            defaultAll={true}
                            field={form.fields.person}
                            itemRender={ (item: any) => `${item.surName} ${item.firstName} (${item.email})`}
                            disabled={false}
                        />

                        <ResourceModal
                            entity="person"
                            entityId="create"
                            title="Add new person"
                        />
                    </ToggleBoxComponent>
                </div>


                <div className="col-xs-12">
                    <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                </div>

            </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/libs/user-attach-person.tsx